(function () {
  'use strict';

  document.addEventListener('contextmenu', function (event) {
    if (
      event.target.tagName === 'IMG' ||
      event.target.closest('img') ||
      event.target.closest('[data-protect-image]')
    ) {
      event.preventDefault();
    }
  });

  document.addEventListener('dragstart', function (event) {
    if (
      event.target.tagName === 'IMG' ||
      event.target.closest('img') ||
      event.target.closest('[data-protect-image]')
    ) {
      event.preventDefault();
    }
  });


  document.addEventListener('selectstart', function (event) {
    if (
      event.target.tagName === 'IMG' ||
      event.target.closest('img') ||
      event.target.closest('[data-protect-image]')
    ) {
      event.preventDefault();
    }
  });

  document.addEventListener('keydown', function (event) {
    const key = event.key.toLowerCase();
    const modifier = event.ctrlKey || event.metaKey;

    if (modifier && key === 's') {
      event.preventDefault();
      return;
    }

    if (modifier && event.shiftKey && key === 's') {
      event.preventDefault();
      return;
    }

    if (
      modifier &&
      key === 'c' &&
      (
        document.activeElement?.tagName === 'IMG' ||
        event.target?.tagName === 'IMG'
      )
    ) {
      event.preventDefault();
      return;
    }
  });


  function protectImages() {
    document.querySelectorAll('img').forEach(function (img) {
      img.setAttribute('draggable', 'false');

      img.style.userSelect = 'none';
      img.style.webkitUserSelect = 'none';
      img.style.webkitUserDrag = 'none';
      img.style.webkitTouchCallout = 'none';
    });
  }


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', protectImages);
  } else {
    protectImages();
  }


  const observer = new MutationObserver(function () {
    protectImages();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

})();